import React from "react";
import { Container, Image } from "react-bootstrap";
import "./Reel.css";

function Reel() {

    return(
        <>
        <br/>
        <Container id="reel">
    
        <Image src="https://via.placeholder.com/1050x500.png?text=Reel+Coming+Soon!" alt="Hannah Ryen" id="reelPlaceholder"></Image>
      
        </Container>
        </>

    )
}

export default Reel;